import React from 'react';
import Box from '@mui/material/Box';
import NewImage from './Modals/NewImage';

const Banner = ({ currentUser, banner, setBanner, socket }) => {
    return (
        !banner.loading && (
            <Box sx={{ position: 'relative', lineHeight: 0 }}>
                <Box
                    component="img"
                    src={`${process.env.REACT_APP_SOCKET_URL}/banner/${banner.id}`}
                    alt="Site Banner"
                    sx={{ width: '100%', height: 'auto', display: 'block' }}
                />
                <NewImage
                    currentUser={currentUser}
                    banner={banner}
                    setBanner={setBanner}
                    socket={socket}
                />
            </Box>
        )
    );
};

export default Banner;
